import {BusinessHoursTimeModel} from '../models/business-hours-time.model';

export class StringUtils {
  static convertToTimeString(n: number) {
    const model = new BusinessHoursTimeModel();
    const hour = n / 60 ^ 0;
    const minutes = `${('0' + n % 60).slice(-2)}`;

    model.demarcation = 'am';
    model.hour24 = hour;
    model.minutes = minutes;
    if (hour < 10) {
      model.time24String = '0' + model.hour24 + ':' + minutes + ':00';
      //model.viewTime24String = '0' + model.hour24 + ':' + minutes + ` ${model.demarcation}`;
    } else {
      model.time24String = model.hour24 + ':' + minutes + ':00';
      //model.viewTime24String = model.hour24 + ':' + minutes + ` ${model.demarcation}`;
    }

    // model.viewTime24String = model.hour24 + ':' + minutes + ` ${model.demarcation}`;

    //model.time24String = model.hour24 + ':' + minutes + ':00';
    model.viewTime24String = model.hour24 + ':' + minutes + ` ${model.demarcation}`;

    let isAddZero = false;
    if (hour < 12) {
      if (hour === 0) {
        model.hour = 12;
      } else {
        model.hour = hour;
      }
    } else {
      model.demarcation = 'pm';
      model.hour = hour;
      if (hour > 12) {
        model.hour = (hour % 12);
        if (model.hour < 10) {
          isAddZero = true;
        }
      }
    }

    if (isAddZero) {
      model.timeString = '0' + model.hour + ':' + minutes + ':00';
      // model.viewTimeString = '0' + model.hour + ':' + minutes + ` ${model.demarcation}`;
    } else {
      model.timeString = model.hour + ':' + minutes + ':00';
      // model.viewTimeString = model.hour + ':' + minutes + ` ${model.demarcation}`;
    }

    model.viewTimeString = model.hour + ':' + minutes + ` ${model.demarcation}`;

    // let val = `0${n / 60 ^ 0}`.slice(-2) + ':' + ('0' + n % 60).slice(-2);
    // if
    return model;
  }

  static convertToViewString(value: string) {
    const arr = value.split(':');
    let hour = parseInt(arr[0]);
    const minute = arr[1];
    let demarcation: string = 'am';

    let isAddZero = false;

    if (hour < 12) {
      if (hour === 0) {
        hour = 12;
      }
    } else {
      demarcation = 'pm';
      if (hour > 12) {
        hour = hour % 12;
      }
    }
    /*if (hour < 10) {
      return '0' + hour.toString() + ':' + minute;
    }*/
    return hour.toString() + ':' + minute;
  }

  static convertViewStringToTime(value: string) {
    const arr = value.split(':');
    let hour = parseInt(arr[0]);
    const minute = arr[1];
    let demarcation: string = 'am';

    let isAddZero = false;

    /*if (hour < 12) {
      if (hour === 0) {
        hour = 12;
      }
    } else {
      demarcation = 'pm';
      if (hour > 12) {
        hour = hour % 12;
      }
    }*/
    const now = new Date(Date.now());
    const date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, parseInt(minute));
    return date;
  }
}
